import React from 'react'
import PropTypes from 'prop-types'
import { ContentAdd } from 'material-ui/svg-icons'
import { FlatButton } from 'material-ui'

const AddSliderButton = ({
  forCustomRecalls = false,
  isDisabled,
  toggleDialog,
}) => (
  <FlatButton
    className="buttonContainer"
    style={{ marginBottom: '5%' }}
    disabled={isDisabled}
    onClick={() => toggleDialog(true, forCustomRecalls ? 'recall' : 'custom pre')}
  >
    <div className="buttonContent">
      <ContentAdd />
      <h3 className="buttonText">
        Add Custom {forCustomRecalls ? 'Recall' : 'Appointment'} Reminder
      </h3>
    </div>
  </FlatButton>
)

AddSliderButton.propTypes = {
  forCustomRecalls: PropTypes.bool,
  isDisabled: PropTypes.bool,
  toggleDialog: PropTypes.func,
}
export default AddSliderButton



// WEBPACK FOOTER //
// ./src/components/Settings/AddSliderButton.js